import React from 'react';
import ReactDOM from 'react-dom';
import 'font-awesome/css/font-awesome.min.css';

import "./styles/variables.scss";
import { App } from './App';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
